import React, { useEffect, memo } from 'react'
import getConfig from 'next/config'
import classnames from 'classnames'

import * as Modal from './modals'
import { useGlobalContext, useGlobalDispatch } from '~/core/context'
import { useApplyChangesButtonStyles } from './styles'
import { useI18n } from '~/core/i18n'

const { PBX_OLD } = getConfig().publicRuntimeConfig

const ApplyChangesButton = () => {
  const [msg] = useI18n()
  const {
    modal,
    pbx: { reload }
  } = useGlobalContext()
  const globalDispatch = useGlobalDispatch()
  const classes = useApplyChangesButtonStyles()

  useEffect(() => {
    const handleMessage = ({ origin, data }) => {
      if (origin === window.location.origin && data === 'reload') {
        globalDispatch({
          type: 'pbx/update',
          payload: {
            reload: true
          }
        })
      }
    }
    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [])

  const handleModalClose = () =>
    globalDispatch({
      type: 'modal/close'
    })

  const handleSuccess = () => {
    globalDispatch({
      type: 'pbx/update',
      payload: {
        reload: false
      }
    })
    handleModalClose()
  }

  const handleOpenModal = () => {
    globalDispatch({
      type: 'modal/open',
      payload: {
        title: msg('system.applychanges.title'),
        isCloseDisabled: false,
        content: (
          <Modal.ApplyChanges
            type="modular-reload"
            onLoadingStateChange={isLoading =>
              globalDispatch({
                type: 'modal/update',
                payload: {
                  isCloseDisabled: isLoading
                }
              })
            }
            onSuccess={handleSuccess}
          />
        )
      }
    })
  }

  return (
    <>
      {/* Temporary FIX for getting updates about apply changes events */}
      <iframe
        src={PBX_OLD + '/admin/index.php?modul=ustredna&system=pbx&view=minframe'}
        style={{ visibility: 'hidden', position: 'absolute', width: 0, height: 0, border: 0 }}
      />
      {reload ? (
        <span
          className={classnames(classes.buttonItem, {
            disabled: !!modal.content
          })}
          title={msg('system.applychanges.title')}
          onClick={handleOpenModal}
        >
          <i className="icon icon-m sidebar-app_nav_item_icon">refresh</i>
        </span>
      ) : null}
    </>
  )
}

export default memo(ApplyChangesButton)
